export enum TemporaryNeedsDataTest {
    TEMPORARY_NEEDS_TITLE = "TEMPORARY_NEEDS_TITLE",
    TEMPORARY_NEEDS_QUESTIONS_SECTION = "TEMPORARY_NEEDS_QUESTIONS_SECTION",
}
